import Vue from 'vue'
import App from './App.vue'
import router from './libs/router'
import request from './libs/request'
import store from './store'
import '@/assets/index.scss'

import{Pagination,Image,Dialog} from 'element-ui'

import AOS from 'aos'
import 'aos/dist/aos.css'
Vue.use(AOS);

import VueClickOutside from 'vue-click-outside';

Vue.directive('click-outside', VueClickOutside);

Vue.config.productionTip = false

Vue.use(Pagination)
Vue.use(Image)
Vue.use(Dialog)

// 使用swiper插件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import VueLazyload from 'vue-lazyload';
//图片懒加载
Vue.use(VueLazyload);


// 将 AOS 挂载到 Vue 原型上，方便全局调用
Vue.prototype.$aos = AOS;

//等图片加载了再初始化，不然banner没高度的话元素会有一瞬间出现在视口内
setTimeout(()=>{
  AOS.init({
    duration:1000,
    once: false, // 允许动画重复触发
    mirror: true, // 滚动反向时也触发动画
  });
},1000)


Vue.prototype.$request=request

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
